import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card, Flex } from '@/shared/antd-imports';
import { NotificationOutlined } from '@ant-design/icons';
import { UpdatesList } from './UpdatesList';

/** Spec 28 §7.5 (stream abill): the Updates section of a project's page in the portal. */
export const ProjectUpdatesCard: React.FC<{ projectId: string }> = ({ projectId }) => {
  const { t } = useTranslation();
  return (
    <Card
      title={
        <Flex gap={8} align="center">
          <NotificationOutlined aria-hidden />
          {t('updates.title', { defaultValue: 'Updates' })}
        </Flex>
      }
      data-testid="project-updates-card"
    >
      <UpdatesList projectId={projectId} />
    </Card>
  );
};
